import { useEffect, useState } from "react";

import { useResolvedStorageUrl } from "@/lib/storageObjectUrls";
import { cn } from "@/lib/utils";

interface AdventureHeroProps {
  imageUrl?: string | null;
  storageBucket?: string;
  badgeLabel: string;
  className?: string;
}

const AdventureHero = ({ imageUrl, storageBucket, badgeLabel, className }: AdventureHeroProps) => {
  const [hasImageError, setHasImageError] = useState(false);
  const storageImageUrl = useResolvedStorageUrl(storageBucket ?? "", storageBucket ? imageUrl : null);
  const resolvedImageUrl = storageBucket ? storageImageUrl : imageUrl ?? null;

  useEffect(() => {
    setHasImageError(false);
  }, [resolvedImageUrl]);

  const showImage = Boolean(resolvedImageUrl && !hasImageError);

  return (
    <div className={cn("relative overflow-hidden", className)}>
      {showImage ? (
        <>
          <img
            src={resolvedImageUrl ?? ""}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
            onError={() => setHasImageError(true)}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
        </>
      ) : (
        <>
          <div className="absolute inset-0 bg-primary" />
          <div
            className="absolute inset-0"
            style={{ background: "linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(107, 53, 102, 0.2) 100%)" }}
          />
        </>
      )}

      <span
        className={cn(
          "relative z-10 inline-flex items-center rounded-full px-3 py-1 text-sm font-medium",
          "bg-white/20 text-white backdrop-blur-sm",
        )}
      >
        {badgeLabel}
      </span>
    </div>
  );
};

export default AdventureHero;
